// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment-module__root--3T6gz"};